import { effect, inject, Injectable } from '@angular/core';

import type { SavedListingRelationship, SavedSearch } from '../../types/saved-items';

import { FilteringService } from '../filtering';
import { ListingsService } from '../listings/listings';
import { StateService } from '../state/state';
import { DeleteSavedItem } from './delete-saved-item';
import { GetDefaultSavedSearchTitle } from './get-default-saved-search-title';
import { GetSavedItems } from './get-saved-items';
import { SaveListing } from './listing';
import { SaveSearch } from './search';

@Injectable({
  providedIn: 'root',
})
export class SaveService {
  protected readonly filteringService = inject(FilteringService);
  protected readonly listingsService = inject(ListingsService);
  protected readonly stateService = inject(StateService);

  constructor() {
    effect(() => {
      if (!this.stateService.userToken()) {
        return;
      }

      // Fetch user saved listings on login.
      void GetSavedItems.call(this, 'listing', ['id, itemId']).then((savedListingIds) => {
        this.filteringService.userSavedListingIds.set(
          savedListingIds as SavedListingRelationship[],
        );
      });

      // Fetch user saved searches on login.
      void GetSavedItems.call(this, 'listing-search', [
        'id',
        'itemId',
        'label',
        'searchString',
      ]).then((savedSearches) => {
        this.filteringService.userSavedSearches.set(savedSearches as SavedSearch[]);
      });

      void GetDefaultSavedSearchTitle.call(this).then((lastSavedSearch) => {
        this.filteringService.userDefaultSavedSearchTitle.set(
          `Homes in The Villages${lastSavedSearch ? ` ${lastSavedSearch + 1}` : ''}`,
        );
      });
    });
  }

  public deleteSavedItem(
    name: string,
    type: 'listing' | 'listing-search' = 'listing',
  ): Promise<boolean> {
    return DeleteSavedItem.call(this, name, type);
  }

  public async saveListing(listingId: string): Promise<string> {
    return SaveListing.call(this, listingId);
  }

  public saveSearch(name: string): Promise<void> {
    return SaveSearch.call(this, name);
  }
}
